import { useCallback, useState } from "react";

import extendedFieldsApi from "ExtendedFields/API";
import extendedFieldHooks from "ExtendedFields/selectorHooks";

const useGroupsWithNetworkField = () => {
  const [networkFieldID] = extendedFieldHooks.useSelectedFieldId();
  const [data, setData] = useState([]);
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const update = useCallback(() => {
    if (!networkFieldID) return;
    setHasError(false);
    setIsLoading(true);
    extendedFieldsApi
      .getGroupsWithNetworkField(networkFieldID)
      .post()
      .then(({ groupsWithField: data }) => setData(data))
      .catch(() => {
        setHasError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [networkFieldID]);

  return [{ data, hasError, isLoading }, update];
};

export { useGroupsWithNetworkField };
